import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import EditQuoteRequest from "./EditQuoteRequest";
import APIConnector from "../../../../apiconnector";
import CommonVariables from "../../../../variables";
import { filterBy } from "@progress/kendo-data-query";
import Notifications from "../../../../Notifications/Messages";
import { Filter, Operators, TextFilter, NumericFilter, DateFilter } from "@progress/kendo-react-data-tools";
import RefreshIcon from '@mui/icons-material/Refresh';
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AccountCircle, TableChart } from "@mui/icons-material";
import { Button } from "@progress/kendo-react-buttons";
import { formatDateOnly } from '../../../../commonfunctions';
/**
 * Quote Queue Component enables users to edit the status and download the attachments.
 */
const QuoteRequest = (props) => {
    //#region " Initialization of State  Values       "
    const initialFilter = {
        logic: "and",
        filters: [{
            field: "accountNumber",
            operator: "contains",
            value: '',
        }]
    };
    const [filter, setFilter] = React.useState(initialFilter);
    const [data, setData] = React.useState([]);
    const [openForm, setOpenForm] = React.useState(false);
    const [editItem, setEditItem] = React.useState();
    const [isCreateMode, setIsCreateMode] = React.useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(null);
    const toolbarButtonBorderColor = "#8b96c7";
    const toolbarButtonHoverBorderColor = "#574ea8";
    const toolbarButtonStyle = {
        marginLeft: "15px",
        marginBottom: "3px",
        font: "caption",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        border: `1px solid ${toolbarButtonBorderColor}`,
        borderRadius: "4px",
        padding: "6px 8px",
        backgroundColor: "#ebefff",
        cursor: "pointer",
        lineHeight: "20px",
        verticalAlign: "middle"
    };
    const toolbarIconStyle = {
        display: "block",
        borderColor: "transparent",
        color: "#5454ec",
        cursor: "pointer",
        fontSize: "18px",
        width: "18px",
        height: "18px"
    };
    const handleToolbarButtonMouseEnter = (event) => {
        event.currentTarget.style.borderColor = toolbarButtonHoverBorderColor;
    };
    const handleToolbarButtonMouseLeave = (event) => {
        event.currentTarget.style.borderColor = toolbarButtonBorderColor;
    };
    //#endregion
    //#region "     On Load         "
    React.useEffect(() => {
        RefreshQuoteRequestGrid()
    }, []);
    const RefreshQuoteRequestGrid = (msg) => {
        let crmInput =
        {
            pageNumber: 1,
            queryCount: 500,
        };
        props.onLoaderRaise(true);
        APIConnector.Post(CommonVariables.urls.GetQuoteQueue, crmInput).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;
            const quoteQueueRecords = (response || []).map((quoteRequest) => ({
                id: quoteRequest.id,
                logicalName: quoteRequest.logicalName,
                requestingUserId: quoteRequest.requestingUserId,
                statusValue: quoteRequest.statusValue,
                status: quoteRequest.status,
                statusId: quoteRequest.statusId,
                accountId: quoteRequest.accountId,
                accountName: quoteRequest.accountName,
                tt_AssignedDate: quoteRequest.tt_AssignedDate,
                tt_CompletionDate: quoteRequest.tt_CompletionDate,
                assignDate: formatDateOnly(quoteRequest.tt_AssignedDate),
                completionDate: formatDateOnly(quoteRequest.tt_CompletionDate),
                createdby: quoteRequest.createdby,
                requestDate: formatDateOnly(quoteRequest.requestDate),
                requestType: quoteRequest.requestType,
                tt_ExtAssigneeId: quoteRequest.tt_ExtAssigneeId,
                extAssignedIdName: quoteRequest.extAssignedIdName,
                needbydate: formatDateOnly(quoteRequest.needbydate),
                specialNotes: quoteRequest.specialNotes,
                responseNotes: quoteRequest.responseNotes,
                accountNumber: quoteRequest.accountNumber,
                userId: quoteRequest.userId
            }));
            setData(quoteQueueRecords);
        });
    };
    //#endregion
    //#region "     Print Functionality     "
    let gridPDFExport;
    const exportPDF = () => {
        if (gridPDFExport) {
            gridPDFExport.save(data);
        }
    };
    //#endregion
    //#region "     Export to Excel functionality    "
    let _export;
    const exportExcel = () => {
        _export.save(data);
    };
    //#endregion
    //#region "     Modal Dialog Events        "
    const getQuoteRequestIdFromResponse = (response) => {
        return response?.id || "";
    };

    const createQuoteRequestNotes = async (quoteRequestId, attachments) => {
        if (!attachments || attachments.length <= 0) {
            return true;
        }

        for (let index = 0; index < attachments.length; index++) {
            const attachment = attachments[index];
            const noteInput = {
                Id: attachment.Id || "00000000-0000-0000-0000-000000000000",
                RegardingObjectId: quoteRequestId,
                TitleFileName: attachment.TitleFileName,
                RegardingObjectType: "quoterequest",
                MimeType: attachment.MimeType,
                FileType: attachment.FileType,
                FileBody: attachment.FileBody,
                CreatedOn: attachment.CreatedOn || null,
                CreatedBy: attachment.CreatedBy || null,
                ModifiedOn: attachment.ModifiedOn || null,
                ModifiedBy: attachment.ModifiedBy || null
            };
            const noteResponse = await APIConnector.Post(CommonVariables.urls.AddAttachmentToQuote, noteInput);
            if (!CommonVariables.isError(noteResponse)) {
                return false;
            }
        }
        return true;
    };
    const getQuoteStatusInput = (statusValue, statusId, status) => {
        const rawStatusValue = statusValue?.statusValue || statusValue || "";
        const rawStatusId = statusValue?.statusId || statusId || "";
        const rawStatus = statusValue?.status ?? status;
        const normalizeStatus = (value) => value === null || value === undefined ? "" : value.toString().trim().toLowerCase().replace(/\s+/g, "");
        const normalizedStatusValue = normalizeStatus(rawStatusValue);
        const normalizedStatusId = normalizeStatus(rawStatusId);
        const normalizedStatus = normalizeStatus(rawStatus);
        if (normalizedStatusId === "openunassigned" || normalizedStatusValue === "open/unassigned" || normalizedStatus === "0" || normalizedStatus === "206340000") {
            return {
                statusValue: "Open/Unassigned",
                statusId: "206340000",
                status: "206340000"
            };
        }
        if (normalizedStatusId === "inprogressassigned" || normalizedStatusValue === "inprogress/assigned" || normalizedStatus === "1" || normalizedStatus === "206340001") {
            return {
                statusValue: "InProgress/Assigned",
                statusId: "206340001",
                status: "206340001"
            };
        }
        if (normalizedStatusId === "completed" || normalizedStatusValue === "completed" || normalizedStatus === "2" || normalizedStatus === "206340002") {
            return {
                statusValue: "Completed",
                statusId: "206340002",
                status: "206340002"
            };
        }
        if (normalizedStatusId === "incomplete" || normalizedStatusValue === "incomplete" || normalizedStatus === "3" || normalizedStatus === "206340003") {
            return {
                statusValue: "Incomplete",
                statusId: "206340003",
                status: "206340003"
            };
        }
        return {
            statusValue: rawStatusValue,
            statusId: rawStatusId,
            status: rawStatus
        };
    };
    const handleSubmit = (event) => {
        if (!event)
            return;
        const attachments = event.attachments || [];
        const statusInput = getQuoteStatusInput(event.statusValue, event.statusId, event.status);
        let quoteRequestInput = {
            Id: isCreateMode ? "00000000-0000-0000-0000-000000000000" : editItem.id,
            LogicalName: event.logicalName,
            RequestingUserId: event.requestingUserId,
            statusValue: statusInput.statusValue,
            status: statusInput.status,
            statusId: statusInput.statusId,
            AccountId: event.accountId,
            AccountName: event.accountName,
            Createdby: event.createdby,
            RequestDate: event.requestDate,
            RequestType: event.requestType,
            tt_extAssignedId: event.tt_extAssignedId,
            needbydate: event.needbydate,
            tt_AssignedDate: event.tt_AssignedDate,
            tt_CompletionDate: event.tt_CompletionDate,
            specialNotes: event.specialNotes,
            responseNotes: event.responseNotes,
            AccountNumber: event.accountNumber
        };
        const apiUrl = isCreateMode
            ? CommonVariables.urls.CreateQuoteRequest
            : CommonVariables.urls.UpdateQuoteRequest;
        props.onLoaderRaise(true, isCreateMode ? "Creating quote request ..." : "Updating quote request ...", { marginTop: "145px" });
        APIConnector.Post(apiUrl, quoteRequestInput).then(async function (response) {
            props.onLoaderRaise(false);
            if (!response) {
                Notifications.ShowErrorMessage("Something went wrong . Please try again");
                return;
            }
            const quoteRequestId = isCreateMode
                ? getQuoteRequestIdFromResponse(response)
                : editItem.id;
            const quoteSavedSuccessfully = response === true
                || response?.isSuccess
                || quoteRequestId;
            if (!quoteSavedSuccessfully) {
                props.onLoaderRaise(false);
                Notifications.ShowErrorMessage("Something went wrong . Please try again");
                return;
            }
            if (attachments.length > 0) {
                if (!quoteRequestId) {
                    props.onLoaderRaise(false);
                    Notifications.ShowErrorMessage("Quote Request was saved, but the Quote Request Id was not returned for attachment upload.");
                    return;
                }
                const notesCreated = await createQuoteRequestNotes(quoteRequestId, attachments);
                if (!notesCreated) {
                    props.onLoaderRaise(false);
                    Notifications.ShowErrorMessage("Quote Request was saved, but attachment upload failed.");
                    return;
                }
            }
            props.onLoaderRaise(false);
            setOpenForm(false);
            setIsCreateMode(false);
            RefreshQuoteRequestGrid(isCreateMode ? "Quote Request Successfully Created." : "Quote Request Successfully Updated.");
        });
    };
    const handleCancelEdit = () => {
        setOpenForm(false);
        setIsCreateMode(false);
        RefreshQuoteRequestGrid("Grid refreshed...")
    };
    const openAddQuoteRequest = () => {
        setIsCreateMode(true);
        setEditItem({
            id: "00000000-0000-0000-0000-000000000000",
            logicalName: "tt_quoterequest",
            accountNumber: "",
            accountName: "",
            accountId: "",
            requestingUserId: "",
            createdby: "",
            requestDate: new Date(),
            requestType: "Quote",
            tt_ExtAssigneeId: "",
            needbydate: new Date(),
            tt_AssignedDate: null,
            tt_CompletionDate: null,
            statusValue: "Open/Unassigned",
            status: "206340000",
            statusId: "206340000",
            specialNotes: "",
            responseNotes: "",
            isCreateMode: true,
            disableAttachmentLoad: true,
            formTitle: "Add Quote Request"
        });
        setOpenForm(true);
    };
    //#endregion
    //#region "     grid        "
    //#region "     Custom Cells    "
    const MyEditCommandCell = (props) => (
        <EditCommandCell {...props} enterEdit={enterEdit} />
    );
    const MyDeleteCommandCell = (props) => (
        <DeleteCommandCell {...props} openDeleteDialog={openDeleteDialog} />
    );
    const EditCommandCell = (props) => {
        return (
            <td style={{ textAlign: "center" }}>
                <span title="Edit">
                    <EditIcon
                        onClick={() => props.enterEdit(props.dataItem)}
                        title="Edit"
                        style={{ display: "inline-block", borderColor: "transparent", color: "#5454ec", cursor: "pointer" }}
                    />
                </span>
            </td>
        );
    };
    const DeleteCommandCell = (props) => {
        return (
            <td style={{ textAlign: "center" }}>
                <span title="Delete">
                    <DeleteIcon
                        onClick={() =>  props.openDeleteDialog(props.dataItem)}
                        title="Delete"
                        style={{ display: "inline-block", borderColor: "transparent", color: "#d51923", cursor: "pointer" }}
                    />
                </span>
            </td>
        );
    }

    const openDeleteDialog = (contactItem) => {
        setDeleteItem(contactItem);
        setDeleteDialogOpen(true);
    };
    const closeDeleteDialog = () => {
        setDeleteItem(null);
        setDeleteDialogOpen(false);
    };
    const confirmDeleteQuoteRequest = () => {
        const quoteId = deleteItem.id;
        setDeleteItem(null);
        if (!quoteId) {
            Notifications.ShowErrorMessage("Quote Id was not found. Please try again.");
            return;
        }

        props.onLoaderRaise(true, "Deleting quote request...", { marginTop: "145px" });
        APIConnector.Post(CommonVariables.urls.DeleteQuoteRequest, { Id: quoteId }).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response)) {
                return;
            }
            if (response === true || response?.isSuccess) {
                Notifications.ShowSuccessMessage("Quote request deleted successfully.");
                RefreshQuoteRequestGrid();
            } else {
                Notifications.ShowErrorMessage((response && response.message) ? response.message : "Failed to delete quote request.");
            }
        });
        setDeleteDialogOpen(false);
    };

    const enterEdit = (item) => {
        setIsCreateMode(false);
        setEditItem({
            ...item,
            isCreateMode: false,
            disableAttachmentLoad: false,
            formTitle: "Edit Quote Request"
        });
                let QRInputJSON = {
            entityName: "tt_quoterequest",
            id: item.id,
        };
        props.onLoaderRaise(true, "Verifying assignment...", { marginTop: "145px" });
        APIConnector.Post(CommonVariables.urls.GetQuoteQueueById, QRInputJSON).then(function (response) {
            props.onLoaderRaise(false);
            if (!CommonVariables.isError(response))
                return;
            if (!response.isSuccess) {
                Notifications.ShowWarningMessage((response && response.message) ? response.message : "Quote assignment to user failed");
                return;
            }
        });
        setOpenForm(true);
    };
    //#endregion
    const grid = (
        <Grid className="rounded-2xl border-b-4" style={{ height: (window.innerHeight - 317) + "px" }}
            data={filterBy(data, filter)}
            sortable={true}
            pageable={true}
            take={1000}
            total={data.length}
            resizable={true}
            selectable={{
                enabled: true,
                drag: false,
                cell: false,
                mode: "single"
            }}>
        <GridNoRecords>
            No Quote's available to request
        </GridNoRecords>
        <Column field="needbydate" width="150" title="Need By Date" />
            <Column field="accountNumber" title="Acct #" width="80" />
        <Column field="accountName" title="School Name" width="250" />
        <Column field="createdby" title="Quote Requested By" width="210" />
        <Column  field="requestDate" width="150" title="Request Date" />
        <Column field="requestType" title="Request Type" width="150" />
        <Column field="extAssignedIdName" title="Assigned To" width="200" />
            <Column field="statusValue" className="getStatus" title="Status" width="160" />
        <Column cell={MyEditCommandCell} width="60" title="Edit" />
        {["INTERNALADMIN","SCHOOLCOORDINATOR","SCHOOLREP"].includes(CommonVariables.getlocalstorageData().RoleName.toUpperCase()) && (
            <Column cell={MyDeleteCommandCell} width="60" title="Delete" />
        )}
    </Grid>);
    //#endregion
    return (
        <div className="PageStyle">
            <h2 className="inline-block pt-1 primary-heading">Quote Queue</h2>
            <div className="row" style={{ "marginRight": "auto" }}>
                <div className="col-sm-8">
                    <Filter
                        value={filter}
                        onChange={(e) => setFilter(e.filter)}
                        fields={[
                            {
                                name: "needbydate",
                                label: "Need By Date",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "accountNumber",
                                label: "Acct #",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "accountName",
                                label: "School Name",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "createdby",
                                label: "Quote Requested By",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "requestDate",
                                label: "Request Date",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "requestType",
                                label: "Request Type",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "extAssignedIdName",
                                label: "Assigned To",
                                filter: TextFilter,
                                operators: Operators.text,
                            },
                            {
                                name: "statusValue",
                                label: "Status",
                                filter: TextFilter,
                                operators: Operators.text,
                            }
                        ]}
                    />
                </div>
                <div className="col-sm-4" style={{ marginTop: "auto", marginRight: "auto", textAlign: "end", paddingLeft: "10px" }}>
                    {(CommonVariables.getlocalstorageData().RoleName != "InternalUser") && 
                        <span
                            title="Add Quote Request"
                            onClick={openAddQuoteRequest}
                            onMouseEnter={handleToolbarButtonMouseEnter}
                            onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Add Quote Request</span>
                        <AccountCircle style={toolbarIconStyle} />
                    </span>}
                    <span
                        title="Export to Excel"
                        onClick={exportExcel}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Export to Excel</span>
                        <TableChart style={toolbarIconStyle} />
                    </span>
                    <span
                        title="Refresh grid"
                        onClick={RefreshQuoteRequestGrid}
                        onMouseEnter={handleToolbarButtonMouseEnter}
                        onMouseLeave={handleToolbarButtonMouseLeave}
                        style={toolbarButtonStyle}
                    >
                        <span>Refresh</span>
                        <RefreshIcon style={toolbarIconStyle} />
                    </span>
                </div>
            </div>
            {grid}
            <ExcelExport data={data} ref={(exporter) => { _export = exporter; }}>
                <Column field="needbydate" title="Need By Date" />
                <Column field="accountNumber" title="Acct #" />
                <Column field="accountName" title="School Name" />
                <Column field="createdby" title="Quote Requested By" />
                <Column field="requestDate" title="Request Date" />
                <Column field="requestType" title="Request Type" />
                <Column field="extAssignedIdName" title="Assigned To" />
                <Column field="statusValue" title="Status" />
            </ExcelExport>
            {openForm && (
                <EditQuoteRequest
                    cancelEdit={handleCancelEdit}
                    onSubmit={handleSubmit}
                    obj={editItem}
                    isCreateMode={isCreateMode}
                    mode={isCreateMode ? "add" : "edit"}
                    title={isCreateMode ? "Add Quote Request" : "Edit Quote Request"}
                    readOnlyAccountNumber={!isCreateMode}
                    disableAttachmentLoad={isCreateMode}
                    showAttachmentSection={!isCreateMode}
                    showNotesFields={true}
                    onLoaderRaise={props.onLoaderRaise}
                />
            )}

                        {deleteDialogOpen && (
                            <div
                                onClick={closeDeleteDialog}
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 12000,
                                    display: "flex",
                                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pointerEvents: "auto"
                                }}
                            >
                                <div
                                    onClick={(event) => event.stopPropagation()}
                                    style={{
                                        width: "360px",
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #d9d9d9",
                                        borderRadius: "6px",
                                        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25)",
                                        pointerEvents: "auto"
                                    }}
                                >
                                    <div
                                        style={{
                                            padding: "10px 14px",
                                            borderBottom: "1px solid #e5e5e5",
                                            fontWeight: "bold",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between"
                                        }}
                                    >
                                        <span>Confirm Delete</span>
                                        <button
                                            type="button"
                                            onClick={closeDeleteDialog}
                                            style={{
                                                border: "none",
                                                backgroundColor: "transparent",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                lineHeight: "18px"
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
            
                                    <div style={{ padding: "14px" }}>
                                        Are you sure you want to delete this quote request?
                                    </div>
            
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "8px",
                                            padding: "10px 14px",
                                            borderTop: "1px solid #e5e5e5"
                                        }}
                                    >
                                        <Button onClick={closeDeleteDialog}>Cancel</Button>
                                        <Button themeColor="error" onClick={confirmDeleteQuoteRequest}>Delete</Button>
                                    </div>
                                </div>
                            </div>
                        )}
        </div>
    );
};
export default QuoteRequest;
